import * as servicesApi from '../services/api/services';

export const REFRESH_ALL_SERVICES_REQUESTED = 'REFRESH_ALL_SERVICES_REQUESTED';
export const REFRESH_ALL_SERVICES_RECEIVED = 'REFRESH_ALL_SERVICES_RECEIVED';
export const REFRESH_USER_SERVICES_RECEIVED = 'REFRESH_USER_SERVICES_RECEIVED';
export const SERVICE_REFERRER_RECEIVED = 'SERVICE_REFERRER_RECEIVED';
export const SERVICE_COUNTRY_CODE_CHANGED = 'SERVICE_COUNTRY_CODE_CHANGED';

export function refreshAllServicesRequested() {
    return {
        type: REFRESH_ALL_SERVICES_REQUESTED
    }
}

export function refreshAllServicesReceived(services) {
    return {
        type: REFRESH_ALL_SERVICES_RECEIVED,
        services
    }
}

export function refreshAllServices(params = {}) {
    return dispatch => {

        dispatch(refreshAllServicesRequested());

        return servicesApi
            .getAll(params)
            .then(res => dispatch(refreshAllServicesReceived(res.payload)))
            .catch(() => dispatch(refreshAllServicesReceived([])));
    }
}

export function refreshUserServicesReceived(services) {
    return {
        type: REFRESH_USER_SERVICES_RECEIVED,
        services
    }
}

export function refreshUserServices(userId) {
    return dispatch => {
        return servicesApi
            .getUserServices(userId)
            .then(res => dispatch(refreshUserServicesReceived(res.payload)));
    }
}

export function refreshServiceReferrer(serviceId) {

    if (!serviceId) {
        return serviceReferrerReceived(null);
    }

    return dispatch => {
        servicesApi
            .getOne(serviceId)
            .then((res) => dispatch(serviceReferrerReceived(res.payload)));
    }
}

export function serviceReferrerReceived(service) {
    return {
        type: SERVICE_REFERRER_RECEIVED,
        service
    }
}

export function assignLicence(serviceId, licenceId, licenceType) {

    return dispatch => {
        return servicesApi
            .assignLicence(serviceId, licenceId, licenceType)
            .then(() => dispatch(refreshAllServices()));
    }
}

export function removeLicence(serviceLicenceId) {

    return dispatch => {
        return servicesApi
            .removeLicence(serviceLicenceId)
            .then(() => dispatch(refreshAllServices()));
    }
}

export function updateSelectedCountry(countryCode) {
    return {
        type: SERVICE_COUNTRY_CODE_CHANGED,
        countryCode
    }
}